module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-screen-929842c78a065ca9687aafd7cf4e987e.png";